/* URBANEK — BRAND MOTION (assets/brand.js)
   Reveal on scroll, parallax, sticky header, kurtyna przejść.
   Respektuje prefers-reduced-motion. Ładowane z theme.liquid (defer). */
(function () {
  "use strict";

  var docEl = document.documentElement;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* 0 · WDOWY — spójniki i przyimki jednoliterowe nie zostają same na końcu wiersza */
  var WIDOW_RE = /(^|\s)([aiouwzAIOUWZ])(\s)/g;

  function fixWidows(scope) {
    var root = scope || document.body;
    if (!root || !("createTreeWalker" in document)) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var tag = node.parentNode && node.parentNode.nodeName;
        if (!tag) return NodeFilter.FILTER_REJECT;
        if (tag === "SCRIPT" || tag === "STYLE" || tag === "TEXTAREA" || tag === "CODE" || tag === "PRE") return NodeFilter.FILTER_REJECT;
        if (node.nodeValue.indexOf(" ") === -1) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (node) {
      WIDOW_RE.lastIndex = 0;
      if (!WIDOW_RE.test(node.nodeValue)) return;
      WIDOW_RE.lastIndex = 0;
      node.nodeValue = node.nodeValue.replace(WIDOW_RE, "$1$2\u00A0");
    });
  }

  /* start */
  function markMediaHero() {
    if (document.querySelector(".urb-chero[data-urb-chero-media]")) {
      docEl.classList.add("urb-has-chero-media");
    }
  }

  function ready() {
    docEl.classList.add("urb-ready");
    fixWidows();
    markMediaHero();
  }
  if (document.readyState !== "loading") ready();
  else document.addEventListener("DOMContentLoaded", ready);

  document.addEventListener("shopify:section:load", function (e) {
    fixWidows(e.target);
    markMediaHero();
  });

  if (reduce) { initRevealFallback(); return; }

  /* 1 · REVEAL ON SCROLL */
  var revealTargets = [];

  function revealEl(el) {
    if (el.classList.contains("is-in")) return;
    if (el.hasAttribute("data-reveal-stagger")) {
      var step = parseInt(el.getAttribute("data-reveal-stagger") || "90", 10) || 90;
      Array.prototype.forEach.call(el.children, function (child, i) {
        child.style.transitionDelay = (i * step) + "ms";
      });
    }
    el.classList.add("is-in");
  }

  function checkReveal() {
    var vh = window.innerHeight || docEl.clientHeight;
    var trigger = vh * 0.88;
    for (var i = revealTargets.length - 1; i >= 0; i--) {
      var el = revealTargets[i];
      var top = el.getBoundingClientRect().top;
      if (top < trigger) {
        revealEl(el);
        revealTargets.splice(i, 1);
      }
    }
  }

  function initReveal() {
    revealTargets = Array.prototype.slice.call(
      document.querySelectorAll("[data-reveal], [data-reveal-stagger]")
    ).filter(function (el) { return !el.classList.contains("is-in"); });
    checkReveal();
    /* bezpiecznik: nic nie zostaje na stałe ukryte */
    setTimeout(function () {
      revealTargets.forEach(revealEl);
      revealTargets = [];
    }, 2600);
  }

  function initRevealFallback() {
    document.querySelectorAll("[data-reveal], [data-reveal-stagger]")
      .forEach(function (el) { el.classList.add("is-in"); });
  }

  /* 2 · HEADER STATE + PARALLAX (jeden rAF na scroll) */
  var parallaxEls = [];
  function collectParallax() {
    parallaxEls = Array.prototype.slice.call(document.querySelectorAll("[data-parallax]"));
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.pageYOffset || docEl.scrollTop;
      docEl.classList.toggle("urb-scrolled", y > 24);
      checkReveal();
      var vh = window.innerHeight;
      for (var i = 0; i < parallaxEls.length; i++) {
        var el = parallaxEls[i];
        var speed = parseFloat(el.getAttribute("data-parallax")) || 0.12;
        var rect = el.getBoundingClientRect();
        var center = rect.top + rect.height / 2 - vh / 2;
        el.style.setProperty("--urb-parallax", (-center * speed).toFixed(1) + "px");
      }
      ticking = false;
    });
  }

  /* 3 · PŁYNNE KOTWICE (#) */
  function initAnchors() {
    document.addEventListener("click", function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute("href");
      if (!id || id === "#" || id.length < 2) return;
      var t = document.querySelector(id);
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: "smooth", block: "start" });
      history.pushState(null, "", id);
    });
  }

  /* 4 · KURTYNA PRZEJŚĆ MIĘDZY STRONAMI */
  function initCurtain() {
    var curtain = document.createElement("div");
    curtain.className = "urb-curtain is-reveal";
    document.body.appendChild(curtain);
    setTimeout(function () { curtain.classList.remove("is-reveal"); }, 1200);

    document.addEventListener("click", function (e) {
      var a = e.target.closest && e.target.closest("a[href]");
      if (!a) return;
      var href = a.getAttribute("href");
      var url;
      try { url = new URL(a.href); } catch (_) { return; }
      /* tylko nawigacja wewnętrzna; nowe karty pomijamy */
      if (a.target === "_blank" || e.metaKey || e.ctrlKey || e.shiftKey) return;
      if (url.origin !== location.origin) return;
      if (href.charAt(0) === "#") return;
      if (url.pathname === location.pathname) return;
      if (a.hasAttribute("data-no-transition")) return;

      e.preventDefault();
      curtain.classList.remove("is-reveal");
      curtain.classList.add("is-cover");
      setTimeout(function () { window.location.href = a.href; }, 340);
    });
  }

  /* boot */
  function boot() {
    initReveal();
    collectParallax();
    initAnchors();
    initCurtain();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", collectParallax, { passive: true });
    onScroll();
  }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);

  /* re-skan po zmianach w edytorze Shopify */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function () {
      initReveal(); collectParallax();
    });
  }
})();
